"use client";

import { ActivityDisplayPreview } from "./previews";

type StretchingDisplayProps = {
  data: Record<string, unknown> | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function StretchingDisplay({
  data,
  participants,
}: StretchingDisplayProps) {
  return (
    <ActivityDisplayPreview
      activityId="stretching"
      data={data}
      participants={participants}
    />
  );
}
